import {Component, model, ModelSignal} from '@angular/core';
import {DynamicFormComponent, DynamicFormControlComponent, IAction} from 'frontier/browserkit';
import {NgIf} from '@angular/common';
import AppControlGuids from '../../../api/ControlGuids';
import {
  JSON_EXPORT_ACTION,
  JSON_IMPORT_ACTION,
} from "frontier/browserkit/src/lib/components/control/table-control/default-form-actions.constant";
import {MatError} from '@angular/material/form-field';

@Component({
  selector: 'app-global-template-config-form',
  templateUrl: '../../../../../projects/frontier/browserkit/src/lib/components/control/form-control/dynamic-form/dynamic-form-control/dynamic-form-control.component.html',
  styleUrl: '../../../../../projects/frontier/browserkit/src/lib/components/control/form-control/dynamic-form/dynamic-form-control/dynamic-form-control.component.scss',
  standalone: true,
  imports: [NgIf, DynamicFormComponent, MatError],
})
export class GlobalTemplateConfigFormComponent extends DynamicFormControlComponent {
  override GUID: string = AppControlGuids.TGlobalTemplateConfigForm;
  override actions: ModelSignal<IAction[]> = model<IAction[]>([
    JSON_EXPORT_ACTION,
    JSON_IMPORT_ACTION,
  ]);
}
